<script setup>
import useAllotTable from "./hooks/useAllotTable";
import useAllotEdit from "./hooks/useAllotEdit";
import Adjust from "./adjust.vue";
import { PROCESS_STATUS, TAG_TYPE } from "@/constants";
import useStashList from "../hooks/useStashList";
import { onMounted } from "vue";

const { stashList } = useStashList();

const {
  searchRef,
  searchData,
  columns,
  tableLoading,
  tableData,
  pages,
  handleSizeChange,
  handleCurrentChange,
  getList,
  handleReset,
  handleExport,
  createDateChange,
  dateRangeSelector,
  handleProcess,
  handleDelete,
} = useAllotTable();

const { adjustRef, handleAdjust } = useAllotEdit();

onMounted(() => {
  getList();
});
</script>

<template>
  <zh-table-page v-bind="{ title: '调拨管理' }">
    <template #header-btn>
      <el-button type="primary" icon="Plus" @click="handleAdjust(null, '0')"
        >新增</el-button
      >
    </template>
    <template #search>
      <el-form :model="searchData" ref="searchRef">
        <el-row :gutter="10">
          <el-col :span="4.5">
            <el-form-item label="调拨单号：" prop="number">
              <el-input v-model="searchData.number" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="4.5">
            <el-form-item label="出库仓库：" prop="outbound">
              <el-select
                v-model="searchData.outbound"
                placeholder="请选择"
                style="width: 200px"
              >
                <el-option
                  v-for="item in stashList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4.5">
            <el-form-item label="入库仓库：" prop="inbound">
              <el-select
                v-model="searchData.inbound"
                placeholder="请选择"
                style="width: 200px"
              >
                <el-option
                  v-for="item in stashList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :sm="8">
            <el-form-item label="创建时间：">
              <el-date-picker
                v-model="dateRangeSelector.createDate"
                type="daterange"
                placeholder="请选择"
                style="width: 90%"
                @change="createDateChange()"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4.5">
            <el-form-item label="创建人" prop="allocateUserText">
              <el-input
                v-model="searchData.allocateUserText"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4.5">
            <el-form-item label="备注：" prop="remark">
              <el-input v-model="searchData.remark" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="4.5">
            <el-form-item label="审核状态：" prop="approvalStatus">
              <el-select
                v-model="searchData.approvalStatus"
                placeholder="请选择"
                style="width: 200px"
              >
                <el-option
                  v-for="item in PROCESS_STATUS"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-button icon="Download" @click="handleExport()">导出</el-button>
      <el-button type="primary" icon="Search" @click="getList()"
        >查询</el-button
      >
      <el-button icon="Refresh" @click="handleReset()">重置</el-button>
    </template>
    <template #table>
      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{
          'text-align': 'center',
        }"
        style="width: 100%; margin-top: 10px"
        max-height="650"
        v-loading="tableLoading"
        :data="tableData"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="单号" prop="number" width="150">
        </el-table-column>
        <el-table-column
          label="出库仓库"
          prop="outBoundWarehouse.name"
          width="150"
        >
        </el-table-column>
        <el-table-column
          label="入库仓库"
          prop="inBoundWarehouse.name"
          width="150"
        >
        </el-table-column>
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :width="item.width || ''"
            show-overflow-tooltip
          >
            <template #default="{ row }">
              <el-tag
                v-if="item.prop == 'approvalStatus'"
                :type="TAG_TYPE[row[item.prop]?.value]"
                >{{ row[item.prop]?.desc }}</el-tag
              >
              <span v-else>{{ row[item.prop] || "-" }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" width="150">
          <!-- <template #default="{ row }">
            <el-button type="primary" link @click="handleAdjust(row, false)"
              >查看</el-button
            >
          </template> -->
          <template #default="{ row }">
            <el-button type="primary" link @click="handleAdjust(row, 2)"
              >查看</el-button
            >
            <el-button
              type="primary"
              link
              @click="handleAdjust(row, 1)"
              v-if="
                row.approvalStatus.value == 1 || row.approvalStatus.value == 4
              "
              >编辑</el-button
            >
            <el-button
              type="danger"
              link
              @click="handleDelete(row.id)"
              v-if="
                row.approvalStatus.value == 1 || row.approvalStatus.value == 4
              "
              >删除</el-button
            >
            <el-button
              type="danger"
              link
              @click="handleProcess(row.approvalId, false)"
              v-if="
                row.approvalStatus.value == 1 || row.approvalStatus.value == 4
              "
              >提交审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="pages.total > 0"
        background
        style="margin-top: 10px"
        :current-page="pages.page"
        :page-size="pages.size"
        :page-sizes="[10, 20, 30, 50]"
        :total="pages.total"
        layout="->, total, prev, pager, next, sizes, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </template>
  </zh-table-page>
  <Adjust ref="adjustRef" @after-save="getList" />
</template>

<style scoped></style>
